// extracted by mini-css-extract-plugin
export default {"page":"wBaq4g","card":"tvuvxo","rules":"mx8UVR","ruleMet":"Nxw18F","error":"OPm37X","success":"AaUcs7"};